import React, { useContext } from 'react';

import WatchlistReview from '~/entities/evaluations/watchlist-review/WatchlistReview';
import JourneyApplicationContext from '~/application-review/context';

interface WatchlistMatchesProps {
  evaluation: {
    entity_token: string;
    evaluation_token: string;
  };
}

const WatchlistMatches = ({ evaluation }: WatchlistMatchesProps) => {
  const { currentAgentIsAssigned } = useContext(JourneyApplicationContext);

  return (
    <WatchlistReview
      canAgentResolve={currentAgentIsAssigned}
      entityToken={evaluation.entity_token}
      evaluationToken={evaluation.evaluation_token}
      showLatestDecisions
    />
  );
};

export default WatchlistMatches;
